(function($) {

	$('.foot-prompt').on('click',function(){
		$('.footer__contact__bar').trigger('click');
	});

})( jQuery );  